import Vue from 'vue'

export function handleError(res, _msg) {
  Vue.prototype.$message.error(_msg || (res && res.msg) || '服务器出了点小差')
}

export function checkLogin() {
  return localStorage.getItem('userInfoApp')
}



// WEBPACK FOOTER //
// ./src/utils/util.js